import Modal from "components/Modal/Modal";
import { useSelector } from "react-redux";
import {
  deletePaymentById,
  deletePayment,
  selectExpense,
  selectPaymentForDeletion,
  selectState,
  setDeletePaymentModalOpen
} from "../../Main/main.slice";
import { useAppDispatch } from "hooks/hooks";
import { toast } from "react-toastify";
import { FormatDate } from "utils/dateUtils";

const DeletePaymentModal = () => {
  const { deletePaymentModalOpen } = useSelector(selectState);
  const expense = useSelector(selectExpense);
  const payment = useSelector(selectPaymentForDeletion);
  const dispatch = useAppDispatch();

  const close = () => {
    dispatch(setDeletePaymentModalOpen({ visible: false, index: -1 }));
  };

  const doDelete = async () => {
    try {
      await dispatch(deletePayment({
        expenseId: expense.expenseId,
        paymentId: payment.paymentId
      }));
      dispatch(deletePaymentById({
        expenseId: expense.expenseId,
        paymentId: payment.paymentId
      }));
      toast.success("Uspešno obrisana.");
      close();
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <Modal
      isOpen={deletePaymentModalOpen}
      onClick={doDelete}
      onClose={close}
      title="Brisanje uplate">
      <p className="info-msg">
        Da li ste sigurni da želite da obrišete sledeću uplatu?
        <br />
        <br />
        <span className="info-msg-left">
          <b>{expense?.title}</b>
          <br />
          <b>Datum: {FormatDate(payment?.date)}</b>
          <br />
          <b>Iznos: {payment?.amount} rsd</b>
          <br />
          <b>Napomena: {payment?.note || "-"}</b>
        </span>
      </p>
    </Modal>
  )
};

export default DeletePaymentModal;
